import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sun, Sparkles, Moon } from 'lucide-react';
const venues = [{
  icon: Sun,
  name: 'DAYTIME',
  tagline: 'Sophisticated Leisure',
  description: 'Discover refined daytime luxury. Artisanal cuisine, craft cocktails, and premium shisha served alongside curated entertainment on our immersive 190ft visual canvas.',
  hours: 'OPEN DAILY',
  href: '/daytime'
}, {
  icon: Sparkles,
  name: 'NIGHTLIFE',
  tagline: 'Elite Entertainment',
  description: 'Where luxury meets celebrity. World-class entertainers, A-list athletes, and exclusive VIP experiences in an atmosphere that rivals the finest destinations globally.',
  hours: '11PM - 3AM',
  href: '/nightlife'
}, {
  icon: Moon,
  name: 'AFTER HOURS',
  tagline: 'The Underground',
  description: "The city's best-kept secret. Curated soundscapes, artisanal mocktails, and intimate conversations in our exclusive late-night sanctuary reserved for connoisseurs.",
  hours: 'WEEKENDS ONLY',
  href: '/after-hours'
}];
export function BottleService() {
  return <div className="min-h-screen bg-[#0B1014] text-white selection:bg-[#DDA247] selection:text-[#0B1014]" data-id="element-764">
      <Header data-id="element-765" />

      {/* Hero Section */}
      <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-766">
        {/* Background */}
        <div className="absolute inset-0 z-0" data-id="element-767">
          <div className="absolute inset-0 bg-gradient-to-b from-[#0B1014] via-[#0B1014]/50 to-[#0B1014] z-10" data-id="element-768" />
          <img src="https://images.unsplash.com/photo-1578736641330-3155e606cd40?q=80&w=2070&auto=format&fit=crop" alt="House of Flavors" className="w-full h-full object-cover opacity-40" data-id="element-769" />
        </div>

        {/* Content */}
        <div className="relative z-20 text-center px-4 max-w-5xl mx-auto" data-id="element-770">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-771">
            <div className="inline-block mb-6" data-id="element-772">
              <span className="text-[#DDA247] text-sm font-bold uppercase tracking-[0.3em] border border-[#DDA247] px-6 py-2" data-id="element-773">
                Dining • Nightlife • Entertainment
              </span>
            </div>
            <h1 className="text-6xl md:text-8xl lg:text-9xl font-bold mb-12 tracking-tight" data-id="element-774">
              HOUSE OF
              <br data-id="element-775" />
              FLAVORS
            </h1>

            <Link to="/book-now" data-id="element-776">
              <Button size="lg" className="min-w-[200px]" data-id="element-777">
                RESERVE NOW
              </Button>
            </Link>
          </motion.div>
        </div>

        {/* Scroll Indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.5,
        duration: 1
      }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20" data-id="element-778">
          <div className="w-[1px] h-24 bg-gradient-to-b from-transparent via-[#DDA247] to-transparent animate-pulse" data-id="element-779" />
        </motion.div>
      </section>

      {/* Content Section */}
      <section className="py-24 px-4 md:px-8 bg-[#0B1014]" data-id="element-780">
        <div className="max-w-7xl mx-auto" data-id="element-781">
          <div className="text-center mb-20" data-id="element-782">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-5xl font-bold text-white mb-4 tracking-wide" data-id="element-783">
              THE ULTIMATE EXPERIENCE
            </motion.h2>
            <motion.div initial={{
            opacity: 0,
            scaleX: 0
          }} whileInView={{
            opacity: 1,
            scaleX: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="w-24 h-1 bg-[#DDA247] mx-auto mb-6" data-id="element-784" />
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-785">
              Three distinct worlds. One extraordinary destination.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-786">
            {venues.map((venue, index) => <motion.div key={venue.name} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15,
            duration: 0.6
          }} data-id="element-787">
                <Link to={venue.href} className="block h-full" data-id="element-788">
                  <div className="bg-[#11161A] border border-white/10 p-10 text-center group hover:border-[#DDA247] transition-colors duration-300 h-full flex flex-col" data-id="element-789">
                    <div className="inline-flex items-center justify-center w-20 h-20 mb-6 bg-[#DDA247]/10 rounded-full group-hover:bg-[#DDA247]/20 transition-colors duration-300 mx-auto" data-id="element-790">
                      <venue.icon className="w-10 h-10 text-[#DDA247]" data-id="element-791" />
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2 tracking-wide" data-id="element-792">
                      {venue.name}
                    </h3>
                    <p className="text-[#DDA247] text-sm font-medium tracking-widest uppercase mb-4" data-id="element-793">
                      {venue.tagline}
                    </p>
                    <p className="text-gray-400 leading-relaxed mb-6 flex-1" data-id="element-794">
                      {venue.description}
                    </p>
                    <div className="pt-4 border-t border-white/10" data-id="element-795">
                      <span className="text-white text-sm font-bold tracking-[0.2em] uppercase" data-id="element-796">
                        {venue.hours}
                      </span>
                    </div>
                  </div>
                </Link>
              </motion.div>)}
          </div>
        </div>
      </section>

      <Footer data-id="element-797" />
    </div>;
}